// src/config/constants.js

export const PLAN_CONFIGS = {
  basic: {
    id: 'basic',
    priceId: process.env.REACT_APP_STRIPE_BASIC_PRICE_ID,
    name: 'Basic Plan',
    description: 'Perfect for getting started',
    credits: 500,
    prices: {
      usd: 2000, // $29.00
      eur: 2000,
      gbp: 2500,
    },
    features: [
      '500 credits per month',
      'Basic analytics',
      'Email support',
      'API access',
      'Up to 3 team members',
      'Core integrations',
    ],
  },
  pro: {
    id: 'pro',
    priceId: process.env.REACT_APP_STRIPE_PRO_PRICE_ID,
    name: 'Pro Plan',
    description: 'For growing businesses',
    credits: 2000,
    prices: {
      usd: 5000, // $79.00
      eur: 5000,
      gbp: 6900,
    },
    features: [
      '2000 credits per month',
      'Advanced analytics',
      'Priority support',
      'Custom branding',
      'Unlimited team members',
      'Advanced integrations',
      'Webhook support',
      'Custom domain',
    ],
  },
  premium: {
    id: 'premium',
    priceId: process.env.REACT_APP_STRIPE_PREMIUM_PRICE_ID,
    name: 'Premium Plan',
    description: 'For large scale operations',
    credits: 5000,
    prices: {
      usd: 10000, // $149.00
      eur: 10000,
      gbp: 12900,
    },
    features: [
      '5000 credits per month',
      'Full analytics suite',
      'Dedicated support',
      'Custom integrations',
      'API rate limits removed',
      'SLA guarantees',
      'Advanced security features',
      'Custom feature development',
      'Dedicated account manager',
      'Enterprise SSO',
    ],
  },
};

export const CREDIT_PACKAGES = {
  small: {
    id: 'credit_small',
    priceId: process.env.REACT_APP_STRIPE_100_CREDITS_PRICE_ID,
    name: '100 Credits',
    description: 'Perfect for small campaigns',
    credits: 100,
    prices: {
      usd: {
        amount: 1000,
        priceId: process.env.REACT_APP_STRIPE_100_CREDITS_USD_PRICE_ID,
      },
      //   eur: {
      //     amount: 1000,
      //     priceId: process.env.REACT_APP_STRIPE_100_CREDITS_EUR_PRICE_ID,
      //   },
      //   gbp: {
      //     amount: 900,
      //     priceId: process.env.REACT_APP_STRIPE_100_CREDITS_GBP_PRICE_ID,
      //   },
    },
  },
  medium: {
    id: 'credit_medium',
    priceId: process.env.REACT_APP_STRIPE_200_CREDITS_PRICE_ID,
    name: '200 Credits',
    description: 'Most popular choice',
    credits: 200,
    prices: {
      usd: {
        amount: 2000,
        priceId: process.env.REACT_APP_STRIPE_200_CREDITS_USD_PRICE_ID,
      },
      //   eur: {
      //     amount: 2000,
      //     priceId: process.env.REACT_APP_STRIPE_200_CREDITS_EUR_PRICE_ID,
      //   },
      //   gbp: {
      //     amount: 1800,
      //     priceId: process.env.REACT_APP_STRIPE_200_CREDITS_GBP_PRICE_ID,
      //   },
    },
  },
  large: {
    id: 'credit_large',
    priceId: process.env.REACT_APP_STRIPE_500_CREDITS_PRICE_ID,
    name: '500 Credits',
    description: 'Best value for high volume',
    credits: 500,
    prices: {
      usd: {
        amount: 5000,
        priceId: process.env.REACT_APP_STRIPE_500_CREDITS_USD_PRICE_ID,
      },
      //   eur: {
      //     amount: 4500,
      //     priceId: process.env.REACT_APP_STRIPE_500_CREDITS_EUR_PRICE_ID,
      //   },
      //   gbp: {
      //     amount: 4000,
      //     priceId: process.env.REACT_APP_STRIPE_500_CREDITS_GBP_PRICE_ID,
      //   },
    },
  },
};

// export const CREDIT_PRICES = {
//   usd: 10, // $0.10 in cents
//   eur: 9, // €0.09 in cents
//   gbp: 8, // £0.08 in cents
// };

// In config/constants.js
export const CREDIT_CONFIGS = {
  maxPurchaseAmount: 10000,
  priceIds: {
    usd: 'price_credit_usd',
    eur: 'price_credit_eur',
    gbp: 'price_credit_gbp',
  },
};

export const SUPPORTED_CURRENCIES = {
  USD: {
    code: 'usd',
    symbol: '$',
    decimal_digits: 2,
    format: '{symbol}{amount}',
  },
  //   EUR: {
  //     code: 'eur',
  //     symbol: '€',
  //     decimal_digits: 2,
  //     format: '{symbol}{amount}',
  //   },
  //   GBP: {
  //     code: 'gbp',
  //     symbol: '£',
  //     decimal_digits: 2,
  //     format: '{symbol}{amount}',
  //   },
};

export const SUBSCRIPTION_STATUSES = {
  INCOMPLETE: 'incomplete',
  ACTIVE: 'active',
  PAST_DUE: 'past_due',
  CANCELED: 'canceled',
  UNPAID: 'unpaid',
  INCOMPLETE_EXPIRED: 'incomplete_expired',
};

export const TRANSACTION_TYPES = {
  SUBSCRIPTION: 'subscription',
  CREDIT_PURCHASE: 'credit_purchase',
  PRORATION: 'proration',
};

export const PENDING_ACTIONS = {
  NONE: null,
  DOWNGRADE: 'downgrade',
  CANCEL: 'cancel',
};

// Constants for credit purchases
export const MIN_CUSTOM_CREDITS = 1;
export const MAX_CUSTOM_CREDITS = 10000;
export const CREDIT_PRICE_CENTS = 10; // $0.10 per credit

// Stripe appearance config
export const STRIPE_APPEARANCE = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#4F46E5',
    colorBackground: '#ffffff',
    colorText: '#1F2937',
    colorDanger: '#EF4444',
    fontFamily:
      'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    spacingUnit: '4px',
    borderRadius: '6px',
  },
};
